import {
  Component, ElementRef, EventEmitter, Input, OnChanges,
  Output, SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { Order } from "../../models/order.model";

@Component({
    selector: 'app-print-order-products',
    templateUrl: './print-order-products.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintOrderProductsComponent implements OnChanges {
  @Input() order: Order;
  @Output() printed = new EventEmitter<string>();
  public pages = [];
  private elRef: ElementRef

  constructor(elRef: ElementRef) {
    this.elRef = elRef;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.order.isFirstChange() || !changes.order.currentValue) {
      this.pages = [];
      return;
    }
    this.print().then(() => {
      setTimeout(() => {
        this.printed.emit(this.elRef.nativeElement.innerHTML);
      }, 0);
    });
  }

  /**
   * Build html content
   */
  private async print(): Promise<void> {
    try {
      await this.buildHtml();
    } catch (err) {
      this.printed.emit(err);
    }
  }

  /**
   * Asynchronously constructs HTML content by processing the products in the order
   * and appending their descriptions to the pages array.
   */
  private buildHtml(): void {
    const products = this.order.products.filter(p => !p.isVersion);
    const versions = this.order.products
      .filter(p => p.isVersion)
      .filter((product, index, self) =>
        index === self.findIndex(p => p.productId === product.productId)
      );
    for (const product of [...products, ...versions]) {
      let numberOfVersions = 0;
      if (product.isVersion) {
        numberOfVersions = this.order.products.filter(p => p.productId === product.productId)?.length ?? 0;
      }
      this.pages.push({ transactionId: this.order.transactionId,
        description: product.description,
        customer: this.order.company  || this.order.contactName, numberOfVersions });
    }
  }
}
